import React, { Fragment } from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import ProjectSection from "../../components/ProjectSection/ProjectSection";
import TestimonialSection from "../../components/TestimonialSection/TestimonialSection";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Logo from "../../images/logo.webp";
import Phone from "../../images/telephone.svg";
import CursorMaus from "../../components/CursorMaus/CursorMaus";

const ProjectPage = () => {
  return (
    <Fragment>
      <Helmet>
        <title>Portfolio | Cash Flow Summit 2026</title>
        <meta
          name="description"
          content="Explore highlights, initiatives, and featured programs connected to Cash Flow Summit 2026."
        />
        <meta
          name="keywords"
          content="Cash Flow Summit portfolio, summit projects, summit highlights"
        />
        <meta name="author" content="Jagmohan Singh" />
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <Navbar Logo={Logo} hclass={"wpo-site-header s3"} telephone={Phone} />
      <PageTitle pageTitle={"Portfolio"} pagesub={"Portfolio"} />
      <ProjectSection hclass={"project-section"} />
      <TestimonialSection />
      <Footer />
      <Scrollbar />
      <CursorMaus />
    </Fragment>
  );
};
export default ProjectPage;
